import type { AnnouncementButton } from "@/server-types";

/** Runs a button's action and returns the id to record as clicked, if any. */
export function runAnnouncementButton(
  button: AnnouncementButton,
  handlers: {
    navigate: (path: string) => void;
    openUrl: (url: string) => void;
  },
): string | undefined {
  if (button.action.type === "dismiss") {
    return undefined;
  }

  const { href } = button.action;
  if (isDashboardPath(href)) {
    handlers.navigate(href);
  } else {
    handlers.openUrl(href);
  }
  return button.id;
}

const DASHBOARD_PATH = /^\/dashboard(?=$|[/?#])/;
const RELATIVE_LINK_BASE = "https://relative.invalid";

/** Whether a link opens a dashboard page, where it should open without reloading the app. Resolved first, like on the server, so `/dashboard/../logout` does not count. */
export function isDashboardPath(href: string): boolean {
  if (!href.startsWith("/")) return false;
  try {
    const url = new URL(href, RELATIVE_LINK_BASE);
    return (
      url.origin === RELATIVE_LINK_BASE && DASHBOARD_PATH.test(url.pathname)
    );
  } catch {
    return false;
  }
}
